import React from 'react';
import { Popover, Typography } from 'antd';
import styled from 'styled-components/macro';
// import { Owner } from '../../../../../../types.generated';
import { CustomAvatar } from '../../../../../shared/avatar';
import { getDescriptionFromType, getNameFromType } from '../../../containers/profile/sidebar/Ownership/ownershipUtils';
import { useEntityRegistry } from '../../../../../useEntityRegistry';

interface Props {
    name: string;
    owner: any;
    hidePopOver?: boolean;
    pictureLink?: string;
    fontSize?: number;
}

const TextWrapper = styled.span<{ fontSize?: number }>`
    ${(props) => props.fontSize && `font-size: ${props.fontSize}px;`}
`;

const ContentWrapper = styled.span`
    display: flex;
    align-items: center;
`;

const OwnerPopoverTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

const OwnerEntityTypeText = styled(Typography.Text)`
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
`;

const OwnerPopoverContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const OwnerNameText = styled(Typography.Text)`
    font-family: 'Manrope', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 4px;
`;

const OwnershipTypeText = styled(Typography.Text)`
    font-family: 'Manrope', sans-serif;
    font-weight: 700;
`;

const OwnwershipTypeDescriptionText = styled(Typography.Text)`
    font-family: 'Manrope', sans-serif;
`;

export default function OwnerContent({ name, owner, hidePopOver, pictureLink, fontSize }: Props) {
    const entityRegistry = useEntityRegistry();
    const ownerEntity = owner.owner;
    const ownerEntityType = owner.owner.type;
    const ownerDisplayName = entityRegistry.getDisplayName(ownerEntityType, ownerEntity);
    const ownerEmail: any = owner.owner?.info?.email || '';

    let ownershipTypeName;
    let ownershipTypeDescription;
    if (owner.ownershipType && owner.ownershipType.info) {
        ownershipTypeName = owner.ownershipType.info.name;
        ownershipTypeDescription = owner.ownershipType.info.description;
    } else if (owner.type) {
        ownershipTypeName = getNameFromType(owner.type);
        ownershipTypeDescription = getDescriptionFromType(owner.type);
    }

    const avatar: React.ReactNode = (
        <CustomAvatar name={name} photoUrl={pictureLink} useDefaultAvatar={false} hideTooltip size={20} />
    );

    /* TODO: We probably do not want render if ownership type has been soft deleted */

    const ownerName = ownerDisplayName === '__datahub_system' ? 'System' : ownerDisplayName;

    const ownerTitle = owner.ownershipType?.info?.name ?? getNameFromType(owner.type);

    return (
        <ContentWrapper>
            {avatar}
            {hidePopOver ? (
                <TextWrapper fontSize={fontSize}>{name}</TextWrapper>
            ) : (
                <Popover
                    placement="left"
                    overlayStyle={{ maxWidth: 300 }}
                    content={
                        <OwnerPopoverContentContainer>
                            <OwnerNameText>{ownerName}</OwnerNameText>
                            <OwnershipTypeText className="f-text-content">{ownerEmail}</OwnershipTypeText>
                            <OwnershipTypeText className="f-text-content">{ownershipTypeName}</OwnershipTypeText>
                            <OwnwershipTypeDescriptionText className="f-text-content f-text-normal">
                                {ownershipTypeDescription}
                            </OwnwershipTypeDescriptionText>
                        </OwnerPopoverContentContainer>
                    }
                    title={
                        <OwnerPopoverTitleContainer>
                            {avatar}
                            <OwnerEntityTypeText strong className="truncate" title={ownerTitle}>
                                {ownerTitle}
                            </OwnerEntityTypeText>
                        </OwnerPopoverTitleContainer>
                    }
                >
                    <TextWrapper>{name}</TextWrapper>
                </Popover>
            )}
        </ContentWrapper>
    );
}
